<dashboardnav>

  <cradua-geo-datum
  [geodatums]="geodatums$ | async"
  (geodatum)="onSubmitGeoDatum($event)"
  (deleteGeoDatumEvent)="onDeleteGeoDatum($event)"
  *ngIf="(isLoading$ | async ) === false"
  >
</cradua-geo-datum>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoading$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
